exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".session-stats_item_2W8 {\n  padding: 5px 20px; }\n  .session-stats_item_2W8:not(:last-child) {\n    border-right: 1px solid rgba(0, 0, 0, 0.1); }\n  .session-stats_item_2W8 label {\n    color: #888; }\n  .session-stats_item_2W8 div {\n    font-size: 1.4em; }\n", "", {"version":3,"sources":["/Users/nicolaythafvelin/efoil/logger-webapp/src/components/session/session-stats.scss"],"names":[],"mappings":"AAIA;EACE,kBAAkB,EAAE;EACpB;IACE,2CAA2C,EAAE;EAC/C;IACE,YAAY,EAAE;EAChB;IACE,iBAAiB,EAAE","file":"session-stats.scss","sourcesContent":[":export {\n  primaryColor: #00bcd4;\n  accentColor: #ff5722; }\n\n.item {\n  padding: 5px 20px; }\n  .item:not(:last-child) {\n    border-right: 1px solid rgba(0, 0, 0, 0.1); }\n  .item label {\n    color: #888; }\n  .item div {\n    font-size: 1.4em; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"primaryColor": "#00bcd4",
	"accentColor": "#ff5722",
	"item": "session-stats_item_2W8"
};